(function () {
  "use strict";

  function initializeCopilotLanding() {
    var root = document.querySelector(".ess-gc[data-page='get-copilot']");
    if (!root || root.dataset.copilotInitialized === "true") return;
    root.dataset.copilotInitialized = "true";

  window.dataLayer = window.dataLayer || [];

  function push(eventName, details) {
    try {
      if (!window.dataLayer || typeof window.dataLayer.push !== "function") {
        window.dataLayer = [];
      }
      window.dataLayer.push(Object.assign({
        event: eventName,
        page_type: "get_copilot_landing",
        page_path: window.location.pathname
      }, details || {}));
    } catch (_error) {
      // Analytics must never interrupt the application or booking flow.
    }
  }

  function loadAnalytics() {
    if (!document.querySelector("script[data-ess-gtm]")) {
      var gtm = document.createElement("script");
      gtm.async = true;
      gtm.dataset.essGtm = "true";
      gtm.src = "https://www.googletagmanager.com/gtm.js?id=GTM-P6HWFFF";
      document.head.appendChild(gtm);
    }

  }

  function activateFrame(button) {
    var shell = button.closest("[data-lazy-frame]");
    if (!shell || !button.dataset.frameSrc) return;

    var iframe = document.createElement("iframe");
    iframe.src = button.dataset.frameSrc;
    iframe.title = button.dataset.frameTitle || "Embedded content";
    iframe.loading = "lazy";
    iframe.allow = "fullscreen; autoplay; encrypted-media";
    iframe.setAttribute("allowfullscreen", "");
    iframe.addEventListener("load", function () {
      push("ess_copilot_embed_loaded", { embed_title: iframe.title });
    }, { once: true });

    shell.replaceChildren(iframe);
  }

  function formatCohort(cohort) {
    var datePart = String(cohort.startAt || "").slice(0, 10);
    var timePart = String(cohort.startAt || "").slice(11, 16);
    var date = new Date(datePart + "T12:00:00Z");
    var label = new Intl.DateTimeFormat("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
      timeZone: "UTC"
    }).format(date);
    var pieces = timePart.split(":");
    var hour = Number(pieces[0] || 0);
    var minute = pieces[1] || "00";
    var meridiem = hour >= 12 ? "PM" : "AM";
    var displayHour = hour % 12 || 12;
    return label + " at " + displayHour + ":" + minute + " " + meridiem + " Central Time";
  }

  function loadCohorts() {
    var shell = root.querySelector("[data-cohort-list]");
    var endpoint = root.dataset.cohortApiUrl;
    if (!shell || !endpoint) return;
    fetch(endpoint, { headers: { accept: "application/json" }, credentials: "omit" })
      .then(function (response) {
        if (!response.ok) throw new Error("cohort_availability_unavailable");
        return response.json();
      })
      .then(function (data) {
        var cohorts = Array.isArray(data.cohorts) ? data.cohorts.slice(0, 2) : [];
        if (!cohorts.length) throw new Error("cohort_availability_unavailable");
        shell.replaceChildren();
        cohorts.forEach(function (cohort) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "gc-cohort-option";
          button.dataset.cohortId = cohort.id;
          button.setAttribute("aria-pressed", "false");
          var copy = document.createElement("span");
          var strong = document.createElement("b");
          strong.textContent = formatCohort(cohort);
          var small = document.createElement("small");
          small.textContent = "Cohort interest only. ESS confirms placement after qualification.";
          copy.append(strong, small);
          var action = document.createElement("b");
          action.textContent = "Prefer this date";
          button.append(copy, action);
          button.addEventListener("click", function () {
            shell.querySelectorAll("[data-cohort-id]").forEach(function (candidate) {
              candidate.setAttribute("aria-pressed", candidate === button ? "true" : "false");
            });
            var field = root.querySelector("#gc-cohort-intent");
            if (field) field.value = cohort.id;
            push("ess_copilot_cohort_preference", { cohort_id: cohort.id, cohort_start: cohort.startAt });
          });
          shell.appendChild(button);
        });
      })
      .catch(function () {
        shell.innerHTML = "<p>Monthly Wednesday sessions are available at 2:00 PM Central Time. We will confirm the next dates with you.</p>";
      });
  }

  function safeBookingUrl(value) {
    try {
      var url = new URL(value);
      return url.protocol === "https:" && url.hostname.toLowerCase() === "engage.temensys.com" && /^\/book\/[^/]+$/.test(url.pathname) ? url.href : "";
    } catch (_error) {
      return "";
    }
  }

  function loadBookingComponent(onError) {
    if (window.customElements && window.customElements.get("temen-booking-calendar")) return;
    var existing = document.querySelector("script[data-temen-booking-component]");
    if (existing) {
      existing.addEventListener("error", onError, { once: true });
      return;
    }
    var script = document.createElement("script");
    script.src = "https://engage.temensys.com/assets/temen-booking-calendar.js";
    script.async = true;
    script.dataset.temenBookingComponent = "true";
    script.addEventListener("error", onError, { once: true });
    document.head.appendChild(script);
  }

  function bookingFallback(safeUrl) {
    var fallback = document.createElement("p");
    fallback.className = "gc-booking-alt";
    var link = document.createElement("a");
    link.href = safeUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.textContent = "Open the secure scheduling page";
    fallback.appendChild(link);
    return fallback;
  }

  function startBooking(bookingUrl, message) {
    var shell = root.querySelector(".gc-booking");
    var safeUrl = safeBookingUrl(bookingUrl);
    if (!shell || !safeUrl) return false;

    try {
      var followup = document.createElement("div");
      followup.className = "gc-booking-followup";
      var heading = document.createElement("h3");
      heading.textContent = "Your application is in. Choose a time now.";
      var copy = document.createElement("p");
      copy.textContent = message || "Pick the time that works best. Your details are already filled in.";
      var calendar = document.createElement("temen-booking-calendar");
      calendar.setAttribute("booking-url", safeUrl);
      followup.append(heading, copy, calendar);
      shell.replaceChildren(followup);
      loadBookingComponent(function () {
        try {
          calendar.replaceWith(bookingFallback(safeUrl));
        } catch (_error) {
          // The direct booking URL remains available on the calendar element.
        }
      });
      push("ess_copilot_application_complete", { booking_prompt_shown: true });
      try {
        shell.scrollIntoView({ behavior: "smooth", block: "start" });
      } catch (_error) {
        // Scrolling support varies by browser and must not affect submission.
      }
    } catch (_error) {
      try {
        shell.replaceChildren(bookingFallback(safeUrl));
      } catch (_fallbackError) {
        return false;
      }
    }
    return true;
  }

  function connectApprovedForm() {
    var form = root.querySelector("#ess-copilot-price-form");
    var endpoint = root.dataset.aiOpsSubmitUrl;
    if (!form || !endpoint || !window.fetch) return;
    var status = form.querySelector("[data-form-status]");
    var submit = form.querySelector("[type='submit']");
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (submit.disabled) return;
      submit.disabled = true;
      status.dataset.state = "working";
      status.textContent = "Sending your application securely...";
      if (!form.dataset.idempotencyKey) {
        form.dataset.idempotencyKey = window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : "shopify-" + Date.now() + "-" + Math.random().toString(36).slice(2);
      }
      var value = function (selector) {
        var field = form.querySelector(selector);
        return field ? String(field.value || "").trim() : "";
      };
      var payload = {
        contactName: value("#gc-contact-name"),
        contactEmail: value("#gc-contact-email"),
        companyName: value("#gc-contact-company"),
        phone: value("#gc-contact-phone"),
        currentMicrosoftPlan: value("#gc-contact-plan"),
        estimatedCopilotSeats: value("#gc-contact-seats"),
        purchaseTiming: value("#gc-contact-timing"),
        need: value("#gc-contact-message"),
        cohortIntentId: value("#gc-cohort-intent")
      };
      fetch(endpoint, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "idempotency-key": form.dataset.idempotencyKey
        },
        credentials: "omit",
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) {
            var error = new Error(data.error || "We could not submit the application.");
            throw error;
          }
          return data;
        });
      }).then(function (data) {
        status.dataset.state = "success";
        status.textContent = data.message || "ESS received your Copilot readiness application.";
        var assignedAe = typeof data.assignedAe === "string" ? data.assignedAe.trim() : "";
        var bookingMessage = assignedAe
          ? "Choose an available time with " + assignedAe + ". If you do not book now, " + assignedAe + " will follow up within three business days."
          : "Choose an available time with your assigned ESS account executive. If you do not book now, we will follow up within three business days.";
        if (!startBooking(data.bookingUrl, bookingMessage)) {
          status.textContent = "Your application was received, but the scheduling calendar could not open. An ESS account executive will follow up within three business days.";
        }
      }).catch(function (error) {
        status.dataset.state = "error";
        status.textContent = error instanceof TypeError
          ? "We could not send your application. Check your connection and try again."
          : error.message || "Please review the form and try again.";
        submit.disabled = false;
      });
    });
  }

  function suppressRetailPopup() {
    document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"].needsclick').forEach(function (popup) {
      popup.remove();
    });
    if (document.body.classList.contains("klaviyo-prevent-body-scrolling")) {
      document.body.classList.remove("klaviyo-prevent-body-scrolling");
    }
  }

  var popupObserver = new MutationObserver(suppressRetailPopup);
  popupObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  window.setTimeout(function () { popupObserver.disconnect(); }, 30000);
  [500, 1500, 3000, 6000, 10000].forEach(function (delay) {
    window.setTimeout(suppressRetailPopup, delay);
  });
  suppressRetailPopup();

  loadAnalytics();
  loadCohorts();
  connectApprovedForm();
  push("ess_copilot_landing_view");

  var offerTabs = Array.prototype.slice.call(root.querySelectorAll("[data-offer-tab]"));
  var offerPanels = Array.prototype.slice.call(root.querySelectorAll("[data-offer-panel]"));

  function selectOfferPath(tab, shouldFocus) {
    if (!tab) return;
    var path = tab.dataset.offerTab;

    offerTabs.forEach(function (candidate) {
      var isSelected = candidate === tab;
      candidate.setAttribute("aria-selected", isSelected ? "true" : "false");
      candidate.tabIndex = isSelected ? 0 : -1;
    });
    offerPanels.forEach(function (panel) {
      panel.hidden = panel.dataset.offerPanel !== path;
    });

    if (shouldFocus) tab.focus();
    push("ess_copilot_offer_path", { offer_path: path });
  }

  offerTabs.forEach(function (tab, index) {
    tab.addEventListener("click", function () { selectOfferPath(tab, false); });
    tab.addEventListener("keydown", function (event) {
      if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
      event.preventDefault();
      var nextIndex = index;
      if (event.key === "ArrowLeft") nextIndex = (index - 1 + offerTabs.length) % offerTabs.length;
      if (event.key === "ArrowRight") nextIndex = (index + 1) % offerTabs.length;
      if (event.key === "Home") nextIndex = 0;
      if (event.key === "End") nextIndex = offerTabs.length - 1;
      selectOfferPath(offerTabs[nextIndex], true);
    });
  });

  root.addEventListener("click", function (event) {
    var target = event.target.closest("[data-track]");
    if (!target) return;

    push("ess_copilot_cta", {
      cta_name: target.dataset.track,
      cta_text: (target.textContent || "").trim().replace(/\s+/g, " ").slice(0, 120),
      cta_href: target.getAttribute("href") || ""
    });

    if (target.dataset.frameSrc) activateFrame(target);
  });

  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeCopilotLanding, { once: true });
  } else {
    initializeCopilotLanding();
  }

})();
